import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import IntlMessageFormat from "intl-messageformat";
import { useDayPicker } from "react-day-picker";
import { DateCalendarContext } from "./DateCalendarContext";
import * as Styled from "./DateCalendar.styled";
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
export function WeekNumber(props) {
    const { number: weekNumber } = props;
    const { classNames } = useDayPicker();
    const { stringMap } = useContext(DateCalendarContext);
    return (_jsx(Styled.WeekNumber, { children: typeof stringMap?.week === "string"
            ? new IntlMessageFormat(stringMap.week).format({
                span: (str) => _jsx("span", { className: classNames.vhidden, children: str }),
                weekNumber
            })
            : stringMap?.week }));
}
